import React from "react";
import { matchPath, useLocation } from "react-router-dom";
import { useTeamsContext } from "../../../state/teams/context";
import { usePlayersContext } from "../../../state/players/context";
import PlayerFormat from "../../../util/player-format";
import TeamImportErrors from "../components/TeamImportErrors";
import { GameRoutes } from "../../../routes/game-routes";

const TeamImportContainer = ({
	onCancel = () => {},
	onSave = () => {},
	TeamImport
}) => {
	const { pathname } = useLocation();
	const match = matchPath({ path: GameRoutes.TEAM_INFORMATION.url }, pathname);
	const { teamSide } = match.params;

	const { state: teamState } = useTeamsContext();
	let team = null;
	if (teamSide === "away") {
		team = teamState.awayTeam();
	} else if (teamSide === "home") {
		team = teamState.homeTeam();
	}

	const {
		state: playersState,
		saveImportPlayers,
		cancelImportPlayers,
		deleteImportPlayers
	} = usePlayersContext();
	const isImporting = playersState.isImporting();
	const players = team ? playersState.players(team.id) : [];
	const hiddenUniforms = [
		PlayerFormat.TeamUniform,
		PlayerFormat.NotSpecifiedUniform
	];
	const filteredPlayers = players.filter(
		(p) => !hiddenUniforms.includes(p.uniform)
	);

	const importedPlayers = playersState.importedPlayers(team.id);
	const importErrors = playersState.importErrors(team.id);

	const showImportErrors = () => {
		return !!importErrors.length;
	};

	const showImportedPlayers = () => {
		return !showImportErrors();
	};

	const cancel = () => {
		cancelImportPlayers();
		onCancel();
	};

	const save = (records) => {
		saveImportPlayers(team.id, records);
		onSave();
	};

	return (
		<>
			{showImportedPlayers() && (
				<TeamImport
					teamId={team.id}
					importedPlayers={importedPlayers}
					players={filteredPlayers}
					onSave={save}
					onCancel={cancel}
					isImporting={isImporting}
					onDeletePlayer={(player) => deleteImportPlayers(team.id, [player])}
				/>
			)}
			{showImportErrors() && (
				<TeamImportErrors errors={importErrors} onCancel={cancel} />
			)}
		</>
	);
};

export default TeamImportContainer;
